import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { EntityContractListParams } from '@/lib/api/domains/entity-contracts';
import type { EntityContractId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/**
 * Consumption layer for entity contracts. Unlike the entity slices
 * (providers/tpas/…), entity-contracts is a flat admin management list scoped
 * to the current entity — a list of the contracts themselves, not a
 * list→sectioned-detail entity. Shape mirrors the list/detail query factories
 * without the section catalog.
 */
export function entityContractListQuery(params: EntityContractListParams) {
  return queryOptions({
    queryKey: keys.entityContracts.list(params),
    queryFn: () => api.entityContracts.list(params),
    staleTime: 30_000,
  });
}

export function entityContractDetailQuery(entityContractId: EntityContractId) {
  return queryOptions({
    queryKey: keys.entityContracts.detail(entityContractId),
    queryFn: () => api.entityContracts.get(entityContractId),
    staleTime: 30_000,
  });
}
